import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UtilService } from '@shared/services/util.service';

@Component({
  selector: 'obc-redirect',
  template: '',
})
export class RedirectComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private utilService: UtilService) {}

  ngOnInit() {
    const { queryParams, data } = this.activatedRoute.snapshot;

    this.router.navigate([data.redirectTo], {
      queryParams,
    });
  }
}
